"use strict";

import { authConstants, commonConstants, responseCodes } from "../_constants";

export const INITIAL_AUTH_STATE = {
  userDetails: {},
  loginOtpTimer: 0,
  forgotformData: {},
  forgetPasswordOtpTimer: 0,
  forgotUserNameOtpTimer: 0,
  params: "",
  passwordResetStatus: undefined,

  forgotPasswordScreenType: commonConstants.FORGOT_PASSWORD_TAB_LIST_SCREEN,

  adminPasswordResetScreenType: authConstants.ADMIN_PASSWORD_RESET_SCREEN,

  expiredPassword: {
    setExpiredPasswordSuccess: false,
  },

  otpResendDetails: {
    emailOtpEnabled: false,
    smsOtpEnabled: false,
  },

  isUserLoggedOut: false,
  isUserRefresh: false,
  isTokenGen: false,
  customerId: null,

  forgotDetails: {},
  isForgotFlowResetSuccess: false,
  accountConfirm: false,
  isAdminPasswordResetRequired: false,

  tabType: commonConstants.CARD_TYPE_TAB_DEBIT,

  forgotMessageShown: true,

  multiTabOpen: false,
};

export function auth(state = INITIAL_AUTH_STATE, action) {
  switch (action.type) {
    case authConstants.FORGOT_USERNAME_VALIDATE_REQUEST:
      return {
        ...state,
        forgotDetails: {},
        loginOtpTimer: 0,
        isForgotFlowResetSuccess: false,
      };

    case authConstants.AUTH_LOGIN_COMPLETE:
      return {
        ...state,
        userDetails: {
          ...action.payload,
        },
        loginOtpTimer:
          action.payload?.otpTimerTimePeriod ?? action.payload?.remainingTime,
      };

    case authConstants.OTP_RESEND_COMPLETE:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...(action.payload || {}),
        },
        loginOtpTimer:
          action.payload?.data?.otpTimerTimePeriod ??
          action.payload?.data?.remainingTime ??
          0,
      };

    case authConstants.SET_ADMIN_PASSWORD_RESET_STATUS:
      return {
        ...state,
        isAdminPasswordResetRequired:
          action?.payload?.isAdminPasswordResetRequested,
      };

    case authConstants.VALIDATE_USERNAME_REQUEST:
      return {
        ...state,
      };

    case authConstants.VALIDATE_USERNAME_COMPLETE:
      return {
        ...state,
      };

    case authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_REQUEST:
      return {
        ...state,
      };

    case authConstants.EXPIRED_PASSWORD_CHANGE_VALUE_COMPLETE:
      return {
        ...state,
        adminPasswordResetScreenType:
          authConstants.ADMIN_PASSWORD_SUCCESS_SCREEN,
      };

    case commonConstants.HIDE_ERROR_CUSTOM_SERVER_MESSAGE:
      return {
        ...state,
      };

    case authConstants.AUTH_REDUCER_INITIATE:
      return INITIAL_AUTH_STATE;

    case authConstants.SET_REFRESH_FLAG:
      return {
        ...state,
        isUserRefresh: action.payload,
      };
    case authConstants.SET_MULTIPLE_TAB_OPEN:
      return {
        ...state,
        multiTabOpen: action.payload,
      };
    case authConstants.AUTH_LOGOUT_REQUEST:
      return {
        ...state,
        isUserLoggedOut: true,
        isUserRefresh: false,
      };
    case authConstants.IDLE_TIMEOUT_LOGOUT_REQUEST:
      return {
        ...state,
        isUserLoggedOut: true,
        isUserRefresh: false,
      };

    case authConstants.CSRF_TOKEN_GEN_COMPLETE:
      return {
        ...state,
        isTokenGen: Boolean(action?.payload?.token),
      };

    case authConstants.CSRF_TOKEN_GEN_ERROR:
      return {
        ...state,
        isTokenGen: false,
      };

    case authConstants.FORGOT_USERNAME_VALIDATE_COMPLETE:
      return {
        ...state,
        forgotDetails: action?.payload?.data,
        forgotUserNameOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };

    case authConstants.FORGOT_USERNAME_VALIDATE_ERROR:
      return {
        ...state,
        forgotDetails: action?.payload?.response?.errorDetails,
        forgotUserNameOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
        isTokenGen: false,
      };

    case authConstants.FORGOT_USERNAME_OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        forgotDetails: {},
        isForgotFlowResetSuccess: true,
        forgetPasswordOtpTimer: 0,
        forgotUserNameOtpTimer: 0,
      };

    case authConstants.FORGOT_PASSWORD_OTP_RESEND_COMPLETE:
      return {
        ...state,
        forgotDetails: action?.payload?.data,
        forgetPasswordOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };

    case authConstants.FORGOT_USERNAME_OTP_RESEND_COMPLETE:
      return {
        ...state,
        forgotDetails: action?.payload?.data,
        forgotUserNameOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };
    case authConstants.FORGOT_PASSWORD_VALIDATE_COMPLETE:
      return {
        ...state,
        forgotDetails: action?.payload?.data,
        forgetPasswordOtpTimer: action?.payload?.data?.otpTimerTimePeriod,
      };

    case authConstants.FORGOT_PASSWORD_VALIDATE_ERROR:
      return {
        ...state,
        forgotDetails: action?.payload?.response?.errorDetails,
        forgetPasswordOtpTimer:
          action?.payload?.response?.errorDetails?.remainingTime,
        isTokenGen: false,
      };

    case authConstants.FORGOT_PASSWORD_OTP_CONFIRM_COMPLETE:
      return {
        ...state,
        customerId: action?.payload?.data.customerId,
        isForgotFlowResetSuccess: true,
        forgotPasswordScreenType:
          commonConstants.FORGOT_PASSWORD_ACCOUNT_DETAILS_SCREEN,
      };

    case authConstants.FORGOT_PASSWORD_ACCOUNT_CONFIRM_COMPLETE:
      return {
        ...state,
        otpConfirmSuccess: false,
        accountConfirm: true,
        forgotPasswordScreenType:
          commonConstants.FORGOT_PASSWORD_RESET_PASSWORD,
      };

    case authConstants.FORGOT_PASSWORD_CHANGE_VALUE_COMPLETE:
      return {
        ...state,
        customerId: null,
        isForgotFlowResetSuccess: true,
        forgotPasswordScreenType:
          commonConstants.FORGOT_PASSWORD_RESET_PASSWORD_SUCCESS_SCREEN,
      };

    case authConstants.SET_FORGOT_PASSWORD_SCREEN_TYPE:
      return {
        ...state,
        forgotPasswordScreenType: action.payload,
      };

    case authConstants.RESET_OTP_CONFIRM_STATE:
      return {
        ...state,
        isForgotFlowResetSuccess: false,
        otpConfirmSuccess: false,
        forgotDetails: {},
        forgetPasswordOtpTimer: 0,
      };

    case authConstants.SET_FORGOT_PASSWORD_FORM_DATA:
      return {
        ...state,
        forgotFormData: action.payload,
      };
    case authConstants.SET_CARD_TAB_SCREEN:
      return {
        ...state,
        tabType: action.payload,
      };
    case authConstants.CLEAR_FORGOT_PASSWORD_DETAILS:
      return {
        ...state,
        forgotDetails: {},
        forgetPasswordOtpTimer: 0,
        forgotUserNameOtpTimer: 0,
      };
    case authConstants.SET_FORGOT_USERNAME_MESSAGE:
      return {
        ...state,
        forgotMessageShown: action?.payload,
      };
  }
  return state;
}

export const INITIAL_KEY_GENERATION_STATE = {
  regenerateKey: false,
  keyGenerationStatus: null,
};

export function keyGeneration(state = INITIAL_KEY_GENERATION_STATE, action) {
  switch (action.type) {
    case authConstants.KEY_GENERATION_REQUEST:
      return {
        ...state,
        keyGenerationStatus: null,
      };
    case authConstants.KEY_GENERATION_COMPLETE:
      return {
        ...state,
        regenerateKey: false,
        keyGenerationStatus: commonConstants.STATUS_SUCCESS,
      };
    case authConstants.KEY_REGENERATION:
      return {
        ...state,
        regenerateKey: true,
        keyGenerationStatus: null,
      };
  }

  return state;
}
